import { RootState } from '@/store';

export const queryStateSelector = (state: RootState) => state.adminPage.queryState;
// export const errorSelector = (state: RootState) => state.adminPage.error;
export const receptionCentersSelector = (state: RootState) => state.adminPage.receptionCenters;
export const stationSettingsSelector = (state: RootState) => state.adminPage.stationSettings;
export const newEntrySelector = (state: RootState) => state.adminPage.newEntry;
